<template>
  <div
    v-if="
      !cookiesAccepted &&
      !['/privacy-policy', '/cookie-policy'].includes($route.path)
    "
    id="cookieConsent"
    class="alert alert-info fixed-bottom m-0"
  >
    <div class="container text-center">
      <span class="mb-0">
        {{ $t("cookie_alert_text") }}

        <router-link to="/cookie-policy" target="_blank">{{
          $t("cookie_policy")
        }}</router-link
        >.
      </span>
      <button @click="acceptCookies" class="btn btn-sm btn-primary">
        {{ $t("i_agree") }}
      </button>
    </div>
  </div>
</template>

<script>
import { _setCookie } from "@/globalFunctions/utilityFunctions.js";

export default {
  computed: {
    cookiesAccepted() {
      return this.$store.getters.cookiesAccepted;
    },
  },
  methods: {
    acceptCookies() {
      // Add code to handle cookie acceptance, e.g., set a cookie or update a flag in Vuex.
      let cookieName = "absent-cookie-policy-consent";
      let cookieLifetime = 365;
      _setCookie(cookieName, 1, cookieLifetime);

      this.$store.commit("cookiesAccepted");
    },
  },
};
</script>

<style scoped>
#cookieConsent {
  background-color: rgba(20, 20, 20, 0.8);
  min-height: 26px;
  font-size: 14px;
  color: #fff;
  padding: 8px 0 8px 0px;

  z-index: 1000;
  border-radius: 0;
}

#cookieConsent a {
  color: #4b8ee7;
  text-decoration: none;
}

#cookieConsent button {
  border-radius: 3px;
}
</style>
